import { render, staticRenderFns } from "./CompanyApprovedHolidays.vue?vue&type=template&id=661db590"
import script from "./CompanyApprovedHolidays.vue?vue&type=script&lang=js"
export * from "./CompanyApprovedHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports